import Vue from 'vue'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'
import { getBroswer } from '@/utils/index'

// 过滤错误类型
const ignoreErrors = [
  'ResizeObserver loop limit exceeded',
  'Request failed with status code 401',
  'Network Error',
  'Navigating to current location',
  'Loading chunk',
  'Unexpected token',
  'Request failed with status code 502',
  'Request failed with status code 504',
  'Request failed with status code 404',
  'load failed with status 404',
  'died in status LOADING_SOURCE_CODE:',
  'Request aborted',
  'Request failed with status code 500',
  'Failed to fetch',
  'timeout of 60000ms exceeded'
]

// 过滤浏览器
const ignoreBrowsers = [
  'IE',
  'QQBrowser',
  'mobile'
]

// 允许的域名
const allowHostnames = [
  // 'dev.zhaoshang.youpin.srv',
  'zhaoshang.xiaomiyoupin.com'
]

if (allowHostnames.includes(location.hostname)) {
  Sentry.init({
    Vue,
    dsn: 'https://fa8962af48524e7885a27979fe67b2fa@sentry.d.xiaomi.net/413',
    ignoreErrors: ignoreErrors,
    integrations: [
      new Integrations.Vue({ Vue, attachProps: true })
    ],
    beforeSend(event) {
      console.log('[SENTRY]', event)
      // 过滤浏览器
      const res = getBroswer()
      if (ignoreBrowsers.includes(res.broswer)) return null
      return event
    }
  })
}
